import { render } from "./HowRafflesWorkModal.vue?vue&type=template&id=2bc03484&scoped=true"
import script from "./HowRafflesWorkModal.vue?vue&type=script&lang=js"
export * from "./HowRafflesWorkModal.vue?vue&type=script&lang=js"

import "./HowRafflesWorkModal.vue?vue&type=style&index=0&id=2bc03484&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc03484"]])

export default __exports__